module.exports = __webpack_public_path__ + "static/media/vf-button-top.d82f7a1a.svg";